import { QueryBuilderDnD } from '@react-querybuilder/dnd'
import { ChangeEvent, useEffect, useState } from 'react'
import * as ReactDnD from 'react-dnd'
import * as ReactDndHtml5Backend from 'react-dnd-html5-backend'
import { Field, OptionList, QueryBuilder, RuleGroupType, defaultValidator, formatQuery } from 'react-querybuilder'

import { CustomValueEditor } from './components/CustomValueEditor'
import { getOperators, getTransformedQuery } from './conditionsBuilder.helper'

import { Copy } from '@/component'

type Props = {
	target: HTMLElement
	getSqlTranslation: string
	saveConditionsTranslation: string
	saveHandlerEndpoint: string
	fetchDataEndpoint: string
	questionnaireId: string
	globalLabelTranslation: string
}

export const ConditionsBuilder = ({
	questionnaireId,
	fetchDataEndpoint,
	saveHandlerEndpoint,
	getSqlTranslation,
	saveConditionsTranslation,
	globalLabelTranslation,
}: Props) => {
	const [query, setQuery] = useState<RuleGroupType>({ combinator: 'and', rules: [] })
	const [fields, setFields] = useState<OptionList<Field>>([])
	const [condition, setCondition] = useState<string>('')
	const [globalValue, setGlobalValue] = useState<boolean>(false)

	useEffect(() => {
		fetchData()
		Copy.init()
	}, [])

	const fetchData = async () => {
		const response = await fetch(fetchDataEndpoint, {
			method: 'POST',
			body: JSON.stringify({ questionnaireId }),
		})

		const { fieldData, defaultName, defaultQuery, global } = await response.json()

		if (fieldData) {
			setFields(fieldData)
		}

		if (defaultQuery) {
			setQuery(JSON.parse(defaultQuery))
		}

		if (defaultName) {
			setCondition(defaultName)
		}

		setGlobalValue(global)
	}

	const saveConditions = () => {
		$.nette.ajax({
			url: saveHandlerEndpoint,
			method: 'POST',
			data: {
				conditionName: condition,
				questionnaireId,
				sql: query.rules.length === 0 ? '' : getTransformedQuery(query, ['#.', '']),
				json: formatQuery(query, 'json'),
				global: globalValue,
			},
		})
	}

	const handleChange = (event: ChangeEvent<HTMLInputElement>) => {
		setGlobalValue(event.target.checked)
	}

	return (
		<div className="space-y-2">
			<div className="input-field w-1/2" data-testing="conditions-name-condtions-builder">
				<label htmlFor="conditions-name"></label>
				<input
					id="conditions-name"
					type="text"
					className="validate"
					value={condition}
					required
					onChange={(event) => setCondition(event.target.value)}
				/>
			</div>
			<div className="input-field relative flex items-start">
				<label className="font-medium text-gray-900">
					<input type="checkbox" className="filled-in" value="" onChange={handleChange} checked={globalValue} />
					<span>{globalLabelTranslation}</span>
				</label>
			</div>

			<QueryBuilderDnD dnd={{ ...ReactDnD, ...ReactDndHtml5Backend }}>
				<QueryBuilder
					fields={fields}
					query={query}
					onQueryChange={(q) => setQuery(q)}
					autoSelectField={false}
					autoSelectOperator={false}
					listsAsArrays
					resetOnOperatorChange
					showCloneButtons
					showCombinatorsBetweenRules
					showNotToggle
					validator={defaultValidator}
					controlClassnames={{ queryBuilder: 'queryBuilder-branches' }}
					controlElements={{ valueEditor: CustomValueEditor }}
					getOperators={(fieldName) => {
						const field = (fields as Field[]).find((fld: Field) => fld.name === fieldName)
						return getOperators(field)
					}}
				/>
			</QueryBuilderDnD>
			<div className="p-2 flex justify-start gap-1">
				<div className="hidden" data-m-copy="sql-copy" data-m-copy-value={getTransformedQuery(query)}></div>
				<button className="btn" data-m-copy-handler="sql-copy" data-testing="sql-copy-btn-condtions-builder">
					{getSqlTranslation} <i className="fal fa-copy"></i>
				</button>

				<button onClick={saveConditions} className="btn" data-testing="sql-save-btn-condtions-builder">
					{saveConditionsTranslation}
				</button>
			</div>
		</div>
	)
}
